export const blockIconsSearchBedroomBaby = (
	<span className='material-symbols-outlined'>bedroom_baby</span>
);
